import { cn } from '@/lib/utils';

export const SWYG_WAVE_MARK_SRC = '/swyg-wave-mark.png';

const SIZE_CLASS = {
  sm: 'h-6',
  md: 'h-9',
  lg: 'h-14',
} as const;

interface SwygWaveMarkProps {
  className?: string;
  size?: keyof typeof SIZE_CLASS;
}

export default function SwygWaveMark({ className, size = 'md' }: SwygWaveMarkProps) {
  return (
    <img
      src={SWYG_WAVE_MARK_SRC}
      alt="SWYG"
      className={cn('w-auto object-contain', SIZE_CLASS[size], className)}
      data-testid="swyg-wave-mark"
    />
  );
}
